import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const getFacilityListApi = createApi({
    reducerPath: 'getFacilityListApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_NOT_SECRET_CODE_LOCAL,
    }),
    endpoints: (build) => {
        return {
            fetchFacilityListData: build.mutation({
                query: (info) => {
                    return {
                        url: `${info.url}/Facility/search_list`,
                        method: 'POST',
                        body: {
                            "amenityIds": info.amenities ? info.amenities.map(el => Number(el)) : [],
                            "activityGroupIds": info.activityGroupIds ? info.activityGroupIds.map(el => Number(el)) : [],
                            "discountDefinitionIds": [
                            ],
                            "discountCategoryIds":
                                info.discountCategoryIds ? info.discountCategoryIds.map(el => Number(el)) : []
                            ,
                            "query": "",
                            "cardIds": info.cards ? info.cards.map(el => Number(el)) : [],
                            "activityGroupName": info.activityFacility,
                            "activityName": info.activityFacility,
                            "cityName": info.city,
                            "facilityName": info.activityFacility,
                            "latitude": info.lat,
                            "longitude": info.lng,
                            "sort": info.sort,
                            "skip": 0,
                            "take": 0
                        }
                    }
                }
            })
        }
    }
})
export const { useFetchFacilityListDataMutation } = getFacilityListApi
export { getFacilityListApi };

